import React, { FunctionComponent, useEffect,useState } from "react";
import Navbar from "../Components/Navbar/Navbar";
import Reports from "../Screens/Reports/Reports";
import { Route, Redirect, useLocation } from "react-router-dom";
import UserPanel from "../Screens/UserPanel/UserPanel";
import AddContacts from "../Screens/AddContacts/AddContacts";
import Task from "../Screens/TasksPanel/TaskPanel";
import Project from "../Screens/ProjectsPanel/ProjectsPanel";
import AddProject from "../Screens/AddProject/AddProject";
import AddTasks from "../Screens/AddTasks/AddTasks";
import Resources from "../Screens/Resources/Resources";
import ContactDetails from "../Screens/ContactDetails/ContactDetails";
import { connect, useDispatch } from "react-redux";
import { fetchOrganizationsUsers, fetchOrganizationsUsersFromMongo } from "../Services/users";
import EditContact from "../Screens/EditContact/EditContact";

import CallLogsPanel from "../Screens/CallLogsPanel/CallLogsPanel";
import ProjectDetails from "../Screens/ProjectDetails/ProjectDetails";
import ProjectEditModal from "../Components/Modals/ProjectEditModal/ProjectEditModal";
import AddFAQ from "../Screens/AddFAQ/AddFAQ";
import FAQPanel from "../Screens/FAQPanel/FAQPanel";
import LeadManagerAnalytics from "../Screens/Analytics/LeadManagerAnalytics";
import ApiDataPanel from "../Screens/ApiDataPanel/ApiDataPanel";
import LeadDistributor from "../Screens/LeadDistributor/LeadDistributor";
import "axios";
import axios from "axios";
import { setBranchUsersList } from "../Redux/actions";
import styles from "../Screens/Analytics/Analytics.module.css";
import EditFAQ from "../Screens/EditFAQ/EditFAQ";
import MiniDrawer from "../Components/AnalyticsSideNav/SideNavBar";
import AnalyticsSideNav from "../Components/AnalyticsSideNav/AnalyticsSideNav";
import Booking from "../Screens/Booking/Booking";
import AddBooking from "../Screens/Booking/AddBooking";
import SubscriptionDetails from "../Screens/SubscriptionDetails/SubscriptionDetails";
import TransactionHistory from "../Screens/TransactionHistory/TransactionHistory";
import PaymentDetails from "../Screens/PaymentDetails/PaymentDetails";
import UpgradeUser from "../Screens/UpgradeUser/UpgradeUser";
import SubscriptionAlert from "../Components/SubscriptionAlert/SubscriptionAlert";
import AppUpdateAlert from "../Components/AppUpdateAlert/AppUpdateAlert";
import { boolean } from "yup";
import ReEnquiredApiDataPanel from "../Screens/ReEnquiredApiDataPanel/ReEnquiredApiDataPanel";
import InvoicePdf from "../Screens/PdfView/InvoicePdf";
import Settings from "../Screens/Settings/Settings";
import AuditLogs from "../Screens/AuditLogs/AuditLogs";
import Delete from "../Screens/DeleteLog/Delete";
import ReenquiredLeads from "../Screens/ReEnquiredLeads/ReenquiredLeads";
// import help from "../Screens/help/help";
import helpModal from "../Components/Modals/help/helpModal";
import Integrations from "../Screens/Integrations/Integrations";
import WhatsappRechargePlans from "../Screens/WhatsappRechargePlans/WhatsappRechargePlans";
import EmailRechargePlans from "../Screens/EmailRechargePlans/EmailRechargePlans";
import moment from "moment";
import {fetchSingleMBData} from "../Services/contacts"
import Response from "../Screens/Response/Response";
import PropWiseResponse from "../Screens/Response/ResponsesPropertyWise";
import HelpSupport from "../Screens/HelpAndSupport/HelpAndSupport";
import { deviceCheck } from "../Values/utils";

type props = {
  user: any;
  history: any;
  leadsStage: any;
  organizationUsers: any;
  showDeactivationAlert: any;
  paymentStatus: any;
  initialParams: any;
};

const LeadManagerRoute: FunctionComponent<props> = ({
  history,
  user,
  leadsStage,
  organizationUsers,
  showDeactivationAlert,
  paymentStatus,
  initialParams
}) => {
  // const [lastAlertTime, setLastAlertTime]:any = useState(null);
  const [showAppUpdateAlert,setShowAppUpdateAlert] = useState(false);
  const dispatcher = useDispatch();
  const [rootRedirectPath, setRootRedirectPath] = useState("/contacts");


  // Handle the case where in the URL redirect parameter is present
  useEffect(() => {
    if (initialParams["redirect"]) {
      setRootRedirectPath(`/${initialParams["redirect"]}`);
      history.push(`/${initialParams["redirect"]}`);
    }
  }, [initialParams])

  useEffect(() => {
    if (user.organization_id) {
      // const unSub = fetchOrganizationsUsers(
      //   dispatcher,
      //   user.organization_id,
      //   user
      // );

      // return () => {
      //   unSub();
      // };
      fetchOrganizationsUsersFromMongo(dispatcher,user.organization_id,user);
    }
  }, [user, dispatcher]);

  useEffect(() => {
    if (user && organizationUsers) {
      let uidList: any[] = [];

      if (user.branchPermission && !user.branchPermission.includes("All")) {
        uidList.push(user.uid);
        organizationUsers.forEach((users: any) => {
          if (users.branch) {
            if (user.branchPermission.includes(users.branch)) {
              uidList.push(users.uid);
            }
          }
        });

        dispatcher(setBranchUsersList(uidList));
      }
      if (user.branchPermission && user.branchPermission.includes("All")) {
        uidList.push(user.uid);
        organizationUsers.forEach((users: any) => {
          uidList.push(users.uid);
        });
        dispatcher(setBranchUsersList(uidList));
      }
    }
  }, [user, organizationUsers]);

  // useEffect(()=>{
  //   let lastAlertTime:any = localStorage.getItem('lastAlertTime');

  //   // If the last alert time was more than 6 hours ago or is null (i.e. it has never been shown)
  //   if (!lastAlertTime || Date.now() - lastAlertTime > 3 * 60 * 60 * 1000) {
  //     // Show the alert
  //     setShowAppUpdateAlert(true);
  //     let currentTime: any = Date.now();

  //     // Update the last alert time in localStorage
  //     localStorage.setItem('lastAlertTime', currentTime);
  //   }
  // },[])


  const location = useLocation();
  let helpPage = location.pathname.includes('/help')?true:false;
  
  return (
    <>
      {(!helpPage || !deviceCheck()) && <Navbar
        props={{ history }}
        title={"Contacts"}
        path={"/"}
        leadManger={true}
        project={"/projects"}
        task={"/tasks"}
        resources={"/resources"}
        callLogs={"/callLogs"}
        faq={"/faqs"}
        apiData={"/apiData"}
        leadDistributor={"/leadDistributor"}
        // auditLog={"/AuditLog"}
      />}
      {((showDeactivationAlert || paymentStatus === false) && history.location.pathname !== "/subscriptionDetails" )&& <SubscriptionAlert paymentStatus={paymentStatus} />}
     {/* {showAppUpdateAlert &&  <AppUpdateAlert setShowAppUpdateAlert={setShowAppUpdateAlert} />} */}
      <div className={styles.parent}>
        <AnalyticsSideNav
          props={{ history }}
          title={"Contacts"}
          path={"/"}
          leadManger={true}
          operationManger={false}
          project={"/projects"}
          task={"/tasks"}
          resources={"/resources"}
          callLogs={"/callLogs"}
          faq={"/faqs"}
          apiData={"/apiData"}
          leadDistributor={"/leadDistributor"}
          help={"/help"}
          mmb={"/mmb"}          
        />
        {
          paymentStatus && 
          <>
                {/* <Route exact path="/" component={UserPanel} /> */}
            <Route exact path="/">
              <Redirect to={rootRedirectPath} />
            </Route>
            <Route exact path="/contacts" component={UserPanel} />
        <Route path="/analytics" component={LeadManagerAnalytics} />
        <Route path="/reports" component={Reports} />
        <Route path="/addProjects" component={AddProject} />
        <Route path="/addTasks" component={AddTasks} />
        <Route path="/contactDetails" component={ContactDetails} />
        <Route path="/tasks" component={Task} />
        <Route path="/projects" component={Project} />
        <Route path="/resources" component={Resources} />
        <Route path="/addContacts" component={AddContacts} />
        <Route path="/editContacts" component={EditContact} />
        <Route path="/callLogs" component={CallLogsPanel} />
        <Route path="/projectDetails" component={ProjectDetails} />
        <Route path="/editProjects" component={ProjectEditModal} />
        <Route path="/addFAQ" component={AddFAQ} />
        <Route path="/editFAQ" component={EditFAQ} />
        <Route path="/faqs" component={FAQPanel} />
        <Route path="/leadDistributor" component={LeadDistributor} />
        <Route path="/apiData" component={ApiDataPanel} />
        <Route path="/integrations" component={Integrations} />
        {/* <Route path="/reenquiredLeads" component={ReEnquiredApiDataPanel} /> */}
        <Route path="/booking" component={Booking} />
        <Route path="/addBooking" component={AddBooking} />
        <Route path="/viewBookingDetails" component={AddBooking} />
          </>
        }
        <Route path="/subscriptionDetails" component={SubscriptionDetails} />
        <Route path="/whatsappRechargePlans" component={WhatsappRechargePlans} />
        <Route path="/emailRechargePlans" component={EmailRechargePlans} />
        {/* <Route path="/transactionHistory" component={TransactionHistory} />
        <Route path="/invoicePdf" component={InvoicePdf} />
        <Route path="/paymentDetails" component={PaymentDetails} />
        <Route path="/upgradeUsers" component={UpgradeUser} /> */}
        <Route path="/settings" component={Settings} />
        <Route path="/auditLogs" component={AuditLogs} />
        <Route path="/help" component={HelpSupport}/>
        {/* <Route path="/reenquiredLeads" component={ReenquiredLeads} /> */}
        {/* <Route path="/deleteLogs" component={Delete} /> */}
        <Route exact path="/response" component={Response} />
        <Route exact path="/propwiseresponse" component={PropWiseResponse} />
        
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    leadsStage: state.leadsStage.stage,
    organizationUsers: state.organizationUsers.data,
    showDeactivationAlert: state.organization.showDeactivationAlert,
    paymentStatus: state.organization.paymentStatus,
    initialParams:state.utils.initialParams,
  };
};
export default connect(mapStateToProps)(LeadManagerRoute);